import { GeneralPostingOptions, PostingTemplate } from '@professocial/professocialTypes/types/commonTypes'
import { PostingError, PostingErrorCode, Restrictions } from '../shared/types/types'
import checkRatio from './checkRatio'
import { NetworkType } from '@3m5/sm_publish-frontend-api'

const validatePosting = (posting: PostingTemplate, restrictions?: Restrictions, generalPostingOptions?: GeneralPostingOptions): PostingError[] => {
  const topicRequired: boolean = generalPostingOptions?.allowTemplateEdit || false
  let error: PostingError[] = []
  const socialMediaNetwork = posting.socialMediaNetwork
  // socialmediaNetwork vorhanden?
  if (!socialMediaNetwork.facebook && !socialMediaNetwork.instagram && !socialMediaNetwork.googleMyBusiness && !socialMediaNetwork.linkedIn) {
    error.push({
      errorCode: PostingErrorCode.errorNoNetwork,
    })
  }

  // message vorhanden?
  if (!posting.content.text || posting.content.text === '') {
    error.push({
      errorCode: PostingErrorCode.errorNoMessage,
    })
  }

  // message lenghs
  if (posting.content.text && generalPostingOptions && generalPostingOptions.maxCharacters) {
    posting.content.text.length >= generalPostingOptions.maxCharacters && error.push({
      errorCode: PostingErrorCode.errorMessageTooLong,
    })
  }

  // abotTopic vorhanden
  if (!posting.aboTopicId && topicRequired) {
    error.push({
      errorCode: PostingErrorCode.errorNoTopic,
    })
  }

  // instagram und Bild / Video vorhanden?
  if (posting.socialMediaNetwork.instagram) {
    if (!posting.content.image && !posting.content.video) {
      error.push({
        errorCode: PostingErrorCode.errorNoImage,
        network: NetworkType.Instagram,
      })
    }
  }

  // Restriktionen prüfen
  if (restrictions) {
    if (posting.content.image && posting.content.image.url) {
      const img = new Image()
      img.src = posting.content.image.url
      img.onload = async function (event) {
        const loadedImage = event.currentTarget as HTMLImageElement
        const width = loadedImage.width
        const height = loadedImage.height
        const ratioError = await checkRatio(width, height, socialMediaNetwork, restrictions)
        if (ratioError) {
          error = error.concat(ratioError)
        }
      }
    } else {
      if (posting.content.video && posting.content.video.url) {
        // todo video noch prüfen
      }
    }
  }
  return error
}

export default validatePosting
